import { ClientRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    clients: []
  },
  mutations: {
    getClients (state, clients) {
      state.clients = []
      state.clients = clients
    }
  },
  actions: {
    // Get
    getClients ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ClientRepository.getAll(obj)
          .then(response => {
            const clients = response.data.data.reverse()
            commit('getClients', clients)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    // Actions    
    createClient (context, client) {
      return new Promise((resolve, reject) => {
        ClientRepository.create(client)
          .then(() => {
            resolve();
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editClient (context, client) {
      return new Promise((resolve, reject) => {
        ClientRepository.update(client)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    deleteClient (context, id) {
      return new Promise((resolve, reject) => {
        ClientRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
